{
  "coursesPage": {
    "delete": {
      "title": "Delete course",
      "description": "Are you sure you want to delete this course?",
      "confirm": "Delete"
    },
    "toasts": {
      "archived": "Course archived",
      "unarchived": "Course unarchived — moved back to draft",
      "bulkPublished_one": "{{count}} course published",
      "bulkPublished_zero": "{{count}} courses published",
      "bulkPublished_other": "{{count}} courses published",
      "noDraftSelected": "No drafts selected",
      "mergeSameTarget": "Select courses other than the target",
      "mergeError": "Failed to merge courses"
    },
    "header": {
      "title": "Courses",
      "subtitle": "Manage your courses and content",
      "publishSelected": "Publish ({{count}})",
      "mergeTooltip": "Turns the selected courses into modules of an existing course",
      "mergeSelected": "Merge as Modules ({{count}})",
      "mergeShort": "Merge",
      "publishAll": "Publish All",
      "newCourse": "New Course"
    },
    "filters": {
      "searchPlaceholder": "Search courses...",
      "filter": "Filter",
      "all": "All",
      "draft": "Draft",
      "published": "Published",
      "archived": "Archived"
    },
    "merge": {
      "title": "Merge as Modules",
      "description_one": "The selected course will be converted into a module inside the target course.",
      "description_zero": "The {{count}} selected courses will be converted into modules inside the target course.",
      "description_other": "The {{count}} selected courses will be converted into modules inside the target course.",
      "targetLabel": "Target course",
      "targetPlaceholder": "Select the target course...",
      "targetHint": "Each selected course becomes a module inside the target course.",
      "listTitle": "Will be converted into modules:",
      "cancel": "Cancel",
      "convert": "Convert"
    },
    "grid": {
      "selectedCount_one": "{{count}} selected",
      "selectedCount_zero": "{{count}} selected",
      "selectedCount_other": "{{count}} selected",
      "selectAll": "Select all",
      "pagination": "Page {{page}} of {{totalPages}} ({{total}} courses)",
      "previous": "Previous",
      "next": "Next",
      "emptyTitle": "No courses found",
      "emptySearch": "Try a different search",
      "emptyHint": "Start by creating your first course",
      "createCourse": "Create Course"
    }
  },
  "courseEdit": {
    "status": {
      "draft": "Draft",
      "published": "Published",
      "archived": "Archived"
    },
    "loading": "Loading course...",
    "notFound": "Course not found",
    "backToCourses": "Back to courses",
    "breadcrumb": "Courses",
    "appearance": "Appearance",
    "viewAsStudent": "View as student",
    "tabs": {
      "basic": "Details",
      "content": "Content",
      "community": "Community"
    },
    "basic": {
      "updated": "Course updated",
      "saveError": "Failed to save course",
      "save": "Save Changes"
    },
    "sectionDialog": {
      "editTitle": "Edit Section",
      "newTitle": "New Section",
      "titleLabel": "Title *",
      "titlePlaceholder": "e.g. React Fundamentals",
      "cancel": "Cancel",
      "save": "Save",
      "create": "Create"
    },
    "linkModule": {
      "defaultTitle": "Link Existing Section",
      "defaultDescription": "Select a section to link to this course",
      "searchPlaceholder": "Search...",
      "counts": "{{lessons}} lessons · {{courses}} courses",
      "link": "Link",
      "noResults": "No results found",
      "allLinked": "All are already linked"
    },
    "content": {
      "errors": {
        "reorderSections": "Failed to reorder modules",
        "reorderChildren": "Failed to reorder sub-modules",
        "deleteSection": "Failed to delete section",
        "unlinkSection": "Failed to unlink section",
        "saveSection": "Failed to save section",
        "linkSection": "Failed to link section",
        "linkModule": "Failed to link module",
        "unlinkModule": "Failed to unlink module"
      },
      "deleteSection": {
        "title": "Delete section",
        "description": "Are you sure you want to delete this section and all of its content?",
        "confirm": "Delete"
      },
      "unlinkSection": {
        "title": "Unlink section",
        "description": "The section will be removed from this course but will still exist. Do you want to continue?",
        "confirm": "Unlink"
      },
      "unlinkModule": {
        "title": "Unlink module",
        "description": "The module will be removed from this section but will still exist. Do you want to continue?",
        "confirm": "Unlink"
      },
      "sectionsCount_one": "{{count}} section",
      "sectionsCount_zero": "{{count}} sections",
      "sectionsCount_other": "{{count}} sections",
      "lessonsCount_one": "{{count}} lesson",
      "lessonsCount_zero": "{{count}} lessons",
      "lessonsCount_other": "{{count}} lessons",
      "modulesCount_one": "{{count}} module",
      "modulesCount_zero": "{{count}} modules",
      "modulesCount_other": "{{count}} modules",
      "sharedCourses_one": "{{count}} course",
      "sharedCourses_zero": "{{count}} courses",
      "sharedCourses_other": "{{count}} courses",
      "newSection": "New Section",
      "linkSection": "Link Section",
      "loading": "Loading...",
      "editSectionTitle": "Edit section",
      "unlinkSectionTitle": "Unlink section",
      "deleteSectionTitle": "Delete section",
      "linkModule": "Link Module",
      "unlinkModuleTitle": "Unlink module",
      "noModules": "No modules linked to this section",
      "emptyTitle": "No sections created yet",
      "emptyHint": "Create sections to organize the course content",
      "createSection": "Create Section",
      "linkExisting": "Link Existing",
      "linkModuleDialog": {
        "title": "Link Module",
        "description": "Select a module to link to this section"
      }
    },
    "community": {
      "unavailable": {
        "locked": "locked showcase",
        "noPosts": "doesn't accept posts"
      },
      "notConfigured": {
        "title": "Community not configured",
        "description": "Set the <code>COMMUNITY_SSO_SECRET</code> variable on the backend and restart the server to enable linking trails to community spaces."
      },
      "linked": "Space linked to the course",
      "unlinked": "Community link removed",
      "saveError": "Failed to save link",
      "spaceLabel": "Community space",
      "loadingSpaces": "Loading spaces...",
      "chooseSpace": "Choose a space",
      "none": "None (no community for this trail)",
      "hint": "This is the course's default space. Each module can override this choice in its own Community tab — when a module has a space set, it takes precedence over the course's.",
      "noSpaces": "No spaces found in the community. Create a space there to be able to link it here.",
      "save": "Save Changes"
    }
  },
  "courseForm": {
    "validation": {
      "titleMin": "Title must be at least 3 characters",
      "bannerRequired": "A banner is required for published courses"
    },
    "title": "Title *",
    "titlePlaceholder": "e.g. Advanced React",
    "shortDescription": "Short Description",
    "shortDescriptionPlaceholder": "A brief description of the course",
    "description": "Full Description",
    "descriptionPlaceholder": "Describe the course content in detail...",
    "images": {
      "title": "Course Images",
      "subtitle": "Add images in different formats for better display across the platform",
      "thumbnail": "Default Thumbnail",
      "thumbnailHint": "Square/default course image",
      "horizontal": "Horizontal Thumbnail (740x415px)",
      "horizontalHint": "Used in banners and horizontal sections (16:9 ratio)",
      "vertical": "Vertical Thumbnail",
      "verticalHint": "Mobile views and grids (9:16 ratio or similar)",
      "banner": "Banner (1920px wide)",
      "bannerHint": "Main full-screen carousel (21:9 or 16:9 wide ratio)",
      "bannerRequired": "— Required to publish"
    },
    "status": "Status *",
    "statusPlaceholder": "Select a status",
    "statusOptions": {
      "draft": "Draft",
      "published": "Published",
      "archived": "Archived"
    },
    "trail": "Learning Trail",
    "trailHint": "Enables the trail view for students",
    "visibility": "For students who haven't bought it",
    "visibilityOptions": {
      "locked": "Visible and locked",
      "hidden": "Hidden"
    },
    "visibilityHints": {
      "locked": "Shows in the catalog with a lock and a buy button. The button uses the Xtreed offer linked to an access group of this course.",
      "hidden": "Only shows to students who already have access. Everyone else can't see it or open it by link."
    }
  },
  "courseFormDialog": {
    "saveError": "Failed to save course",
    "title": "New Course",
    "description": "Fill in the details to create a new course",
    "cancel": "Cancel",
    "submit": "Create Course"
  },
  "courseCard": {
    "status": {
      "draft": "Draft",
      "published": "Published",
      "archived": "Archived"
    },
    "selectAria": "Select {{title}}",
    "students_one": "<num>{{count}}</num> student",
    "students_zero": "<num>{{count}}</num> students",
    "students_other": "<num>{{count}}</num> students",
    "modules_one": "{{count}} module",
    "modules_zero": "{{count}} modules",
    "modules_other": "{{count}} modules",
    "lessons_one": "{{count}} lesson",
    "lessons_zero": "{{count}} lessons",
    "lessons_other": "{{count}} lessons",
    "editAria": "Edit {{title}}",
    "edit": "Edit",
    "editTooltip": "Edit course, details and content",
    "appearanceAria": "Edit appearance of {{title}}",
    "appearance": "Appearance",
    "appearanceTooltip": "Course page, sections and menu",
    "moreActionsAria": "More actions for {{title}}",
    "moreActions": "More actions",
    "viewAsStudent": "View as student",
    "publish": "Publish",
    "archive": "Archive",
    "unarchive": "Unarchive",
    "mergeAsModule": "Merge as Module",
    "delete": "Delete"
  },
  "levelForm": {
    "validation": {
      "nameRequired": "Name is required",
      "minPointsMin": "Minimum points must be >= 0"
    },
    "updated": "Level updated successfully!",
    "created": "Level created successfully!",
    "saveError": "Failed to save level",
    "editTitle": "Edit Level",
    "createTitle": "Create Level",
    "description": "Configure the level details",
    "name": "Level name",
    "namePlaceholder": "e.g. Level 1",
    "minPoints": "Minimum points",
    "maxPoints": "Maximum points",
    "optional": "Optional",
    "color": "Color (hex)",
    "order": "Order",
    "cancel": "Cancel",
    "saving": "Saving...",
    "save": "Save",
    "create": "Create"
  },
  "categories": {
    "toasts": {
      "created": "Category created successfully",
      "createError": "Failed to create category",
      "updated": "Category updated successfully",
      "updateError": "Failed to update category",
      "deleted": "Category deleted successfully",
      "deleteError": "Failed to delete category"
    },
    "validation": {
      "nameMin": "Name must be at least 2 characters"
    },
    "title": "Categories",
    "subtitle": "Manage your course categories",
    "new": "New Category",
    "emptyTitle": "No categories",
    "emptyHint": "Create your first category to organize your courses",
    "create": "Create Category",
    "coursesCount_one": "{{count}} course",
    "coursesCount_zero": "{{count}} courses",
    "coursesCount_other": "{{count}} courses",
    "dialog": {
      "editTitle": "Edit Category",
      "newTitle": "New Category",
      "editDescription": "Edit the category details",
      "newDescription": "Fill in the details to create a new category",
      "name": "Name *",
      "namePlaceholder": "e.g. Web Development",
      "description": "Description",
      "descriptionPlaceholder": "A brief description of the category...",
      "color": "Color",
      "customColor": "Or pick a custom color",
      "cancel": "Cancel",
      "save": "Save",
      "create": "Create"
    },
    "delete": {
      "title": "Delete category?",
      "description": "Are you sure you want to delete the category <bold>{{name}}</bold>? Associated courses will be left without a category.",
      "cancel": "Cancel",
      "confirm": "Delete"
    }
  },
  "trailForm": {
    "validation": {
      "titleRequired": "Title is required",
      "slugRequired": "Slug is required",
      "productRequired": "Product is required"
    },
    "basicInfo": "Basic Information",
    "title": "Title",
    "titlePlaceholder": "Trail name",
    "slugPlaceholder": "trail-name",
    "slugHint": "Friendly URL for the trail (generated automatically)",
    "description": "Description",
    "descriptionPlaceholder": "Describe what students will learn in this trail",
    "thumbnail": "Cover Image (URL)",
    "settings": "Settings",
    "estimatedHours": "Estimated Time (hours)",
    "difficulty": "Difficulty",
    "difficultyPlaceholder": "Select a difficulty",
    "difficultyOptions": {
      "beginner": "Beginner",
      "intermediate": "Intermediate",
      "advanced": "Advanced"
    },
    "publish": "Publish Trail",
    "publishHint": "Makes the trail visible to students",
    "tags": "Tags",
    "newTag": "New tag",
    "steps": {
      "title": "Trail Courses",
      "add": "Add Course",
      "emptyTitle": "No courses added yet.",
      "emptyHint": "Click \"Add Course\" to get started.",
      "course": "Course",
      "coursePlaceholder": "Select a course",
      "delay": "Delay (days)",
      "delayHint": "Days to unlock after the previous step",
      "required": "Required"
    },
    "cancel": "Cancel",
    "saving": "Saving...",
    "save": "Save Trail"
  }
}
